export function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function clearCanvas(context) {
  context.globalCompositeOperation = "source-over";
  context.setTransform(1, 0, 0, 1, 0, 0);
  context.clearRect(0, 0, context.canvas.width, context.canvas.height);
  context.beginPath();
}

export function getAsync(url, callback, isHtml = false) {
  var ajax = new XMLHttpRequest();
  ajax.open("GET", url, true);
  ajax.onload = function () {
    try {
      callback(isHtml ? ajax.responseText : JSON.parse(ajax.responseText));
    } catch (e) {
      console.error("invalid response");
      console.error(e);
    }
  };
  ajax.send();
}

// GET a JSON resource, rejecting on network error, HTTP error or timeout.
// cache: 'no-cache' makes the browser revalidate (ETag) instead of serving a
// heuristically "fresh" copy: the data endpoints send no Cache-Control header.
export function fetchJson(url, {timeoutMs = 20000} = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  return fetch(url, {cache: 'no-cache', signal: controller.signal})
    .then((resp) => {
      if (!resp.ok) {
        throw new Error(`HTTP ${resp.status} on ${url}`);
      }
      return resp.json();
    })
    .finally(() => clearTimeout(timer));
}

export function postAsync(url, content, callback) {
  var ajax = new XMLHttpRequest();
  ajax.open("POST", url, true);
  ajax.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  ajax.onload = function () {
    callback(ajax.responseText);
  };
  ajax.send(content);
}

export function postFetch(url, content, headers = {}) {
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: content
  }).then((resp) => resp.json());
}
